import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=3a0a8847&scoped=true&"
import script from "./Period.vue?vue&type=script&lang=js&"
export * from "./Period.vue?vue&type=script&lang=js&"
import style0 from "./Period.vue?vue&type=style&index=0&id=3a0a8847&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a8847",
  null
  
)

export default component.exports